module.exports = __webpack_public_path__ + "img/gateway-light-switch-md.69c2299a.svg";